<template>
    <div
        ref="elTagsContainer"
        :data-component="$options.name"
        class="flex flex-wrap gap-8 overflow-hidden"
        :style="{ 'max-height': maxHeight }"
    >
        <cs-tag
            v-for="(tag, index) in tags"
            :key="tag"
            :class="{ invisible: shouldHideTag(index) }"
        >
            {{ index === indexOfLastTagInMaxRow ? '+ weitere' : tag }}
        </cs-tag>
    </div>
</template>
<script lang="ts" src="./MsDynamicTags.ts" />
